<div class="flex flex-col justify-center">
  <ng-container *ngIf="currenctCount === 0">
    <mat-icon class="text-green-600" matTooltip="No booking conflicts"
      >verified
    </mat-icon>
  </ng-container>

  <ng-container *ngIf="currenctCount > 0">
    <mat-icon
      class="cursor-pointer text-yellow-500"
      matTooltip="Has booking conflicts"
      (click)="showConflictsDialog()"
    >
      warning
    </mat-icon>
  </ng-container>
</div>
